import { AsyncActionHandler } from 'action-handler';
import { getPayloadType } from 'utils';

import { fetchInstalledApps, fetchInstalledAppsStatus } from 'actions/registry';
import { fetchManyHasSettings } from 'actions/gallery';

const syncInstalledApps = new AsyncActionHandler({
  name: 'sync_installed_apps',
  defaultState: {
    syncTimeoutHandler: null,
    visibilityChangeHandler: null,
    lastSyncInstalledApps: 0
  },
  handler: ({
    force,
    reset = false,
    getAppData = false,
    clocksAndApps = false
  } = {}) => async (dispatch, getState) => {
    const { gallery, location } = getState();
    const { syncInterval, lastSyncInstalledApps } = gallery;
    let { syncTimeoutHandler, visibilityChangeHandler } = gallery;

    if (syncTimeoutHandler) {
      clearTimeout(syncTimeoutHandler);
    }
    if (visibilityChangeHandler) {
      document.removeEventListener('visibilitychange', visibilityChangeHandler);
    }

    if (
      force ||
      (!reset && lastSyncInstalledApps < Date.now() - syncInterval) ||
      getAppData
    ) {
      if (getAppData) {
        if (clocksAndApps) {
          await dispatch(fetchInstalledApps());
        } else {
          await dispatch(fetchInstalledApps(getPayloadType(location.payload)));
        }
      } else {
        await dispatch(fetchInstalledAppsStatus());
      }

      await dispatch(fetchManyHasSettings());
    }

    if (!syncInterval) {
      return {
        syncTimeoutHandler: null
      };
    }

    // only schedule another app status sync if the app is visible
    if (document.visibilityState === 'visible') {
      syncTimeoutHandler = setTimeout(
        () => dispatch(syncInstalledApps.actionCreator()),
        syncInterval
      );
    }

    // stop polling for app status when app is not visible
    visibilityChangeHandler = () => {
      if (document.visibilityState === 'visible') {
        dispatch(syncInstalledApps.actionCreator());
      } else {
        if (syncTimeoutHandler) {
          clearTimeout(syncTimeoutHandler);
        }
      }
    };
    document.addEventListener('visibilitychange', visibilityChangeHandler);

    return {
      syncTimeoutHandler,
      visibilityChangeHandler,
      lastSyncInstalledApps: Date.now()
    };
  },
  reduce(
    _,
    { syncTimeoutHandler, visibilityChangeHandler, lastSyncInstalledApps }
  ) {
    return {
      syncTimeoutHandler,
      visibilityChangeHandler,
      lastSyncInstalledApps
    };
  }
});

export default syncInstalledApps;
